var _style, _path, _defs, _defs2, _polyline, _polyline2, _defs3, _defs4, _path2, _polyline3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.3 626.5",
    style: {
      enableBackground: "new 0 0 566.3 626.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{clip-path:url(#SVGID_4_);fill:url(#SVGID_5_);}\n\t.st3{clip-path:url(#SVGID_4_);fill:url(#SVGID_6_);}\n\t.st4{clip-path:url(#SVGID_8_);}\n\t.st5{clip-path:url(#SVGID_10_);fill:url(#SVGID_11_);}\n\t.st6{clip-path:url(#SVGID_10_);fill:url(#SVGID_12_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M357.3,756.5c-84.1-0.3-154.3-64.3-162.3-148.1l-8.4-87.8l-55.4-46.9c-55.7-47.4-67.7-128.7-27.8-190.1 c13-20.3,37.5-30,60.9-24.1c23.5,5.6,40.7,25.6,42.8,49.6l18.2,191.3l0.8,0.7c25,21.2,62.4,18.1,83.5-6.9c3.2-3.8,5.9-8,8.1-12.4 L463,182.8c15.5-32.2,48-52.7,83.8-52.8c0.2,0,0.3,0,0.5,0c35.6-0.1,68.1,20,83.8,51.9c35.6,71.3,6.6,158-64.7,193.5 c-9.9,4.9-20.3,8.7-31,11.3c-26.7,6.3-43.6,32.6-38.2,59.5l22.2,112.1C535,637.2,491.9,715.9,417,745.1 C398,752.6,377.7,756.4,357.3,756.5 M230,549.4l5.2,55.2c6.4,67.6,66.4,117.2,134,110.8c11.3-1.1,22.5-3.7,33.1-7.9 c56.7-22.1,89.4-81.7,77.5-141.4L457.5,454c-9.7-48.2,20.6-95.4,68.5-106.7c55.8-13.3,90.3-69.3,77-125.1 c-1.8-7.7-4.6-15.2-8.1-22.3c-9.3-18.6-27.2-29.9-48-29.5c-20.4-0.1-39,11.6-47.7,30L354.1,499.4C331.7,545.4,278,567,230,549.4 L230,549.4 M150.6,298.2c-5.4-0.1-10.5,2.7-13.3,7.4c-28.7,44.3-20.1,103,20.1,137.2l23.8,20.2l-14.3-150.1 c-0.5-6.9-5.5-12.7-12.2-14.2C153.3,298.4,152,298.2,150.6,298.2L150.6,298.2"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_1_",
    points: "176.4,412 225.3,412 225.3,500.4 176.4,500.4 176.4,412  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_3_",
    points: "225.3,500.4 181.2,463 176.4,412 219,434.2 225.3,500.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 594.1994,
    x2: 1,
    y2: 594.1994,
    gradientTransform: "matrix(0.5403 -0.8508 0.7484 0.4753 -332.7971 260.4421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "176.4,412.1 176.4,412.1 181.2,463 181.2,463 176.4,412.1 176.4,412.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 626.4748,
    x2: 1,
    y2: 626.4748,
    gradientTransform: "matrix(0.5403 -0.8508 0.7484 0.4753 -332.7971 260.4421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "176.4,412.1 181.2,463 181.2,463 181.2,463 225.3,500.4 225.3,500.4 219,434.2 176.4,412.1  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_7_",
    points: "186.7,520.6 234.6,520.6 234.6,600.9 186.7,600.9 186.7,520.6  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_9_",
    points: "186.7,520.6 230,549.4 234.7,600.9 192,578.8 186.7,520.6  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 609.3065,
    x2: 1,
    y2: 609.3065,
    gradientTransform: "matrix(0.7257 -0.8337 0.805 0.7007 -379.44 220.4061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M230,549.4L230,549.4l0,0.3L230,549.4C230,549.4,230,549.4,230,549.4 M186.8,521.4l5.2,57.4l0.2,0.1 L186.8,521.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 626.465,
    x2: 1,
    y2: 626.465,
    gradientTransform: "matrix(0.7257 -0.8337 0.805 0.7007 -379.44 220.4061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C6C6C6"
    }
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "186.7,520.6 186.7,520.6 186.8,521.4 192.2,578.9 234.7,600.9 234.6,600.9 230,549.7 230,549.4  230,549.4 230,549.4 230,549.4 186.7,520.6  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLogo);
export default __webpack_public_path__ + "static/media/backgroundLogo.2efb5dddb95f2dc8c66f23bb5b2a544b.svg";
export { ForwardRef as ReactComponent };